/**
 * Constants for IndexedDB index keys
 * These constants ensure consistency across all repository and operation classes.
 */
export class DexieIndexKeys {
	/**
	 * Private constructor to prevent instantiation of this utility class.
	 */
	private constructor() { }

	/**
	 * Individual index keys for sync data table.
	 */
	public static readonly ID = 'Id';
	public static readonly USER_NAME = 'UserName';
	public static readonly CROWN_ID = 'CrownId';
	public static readonly LEGACY_ID = 'LegacyId';
	public static readonly SYNC_TYPE = 'SyncType';
	public static readonly SERVICE_ID = 'ServiceId';
}
